// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8AxOs","field":"styles_field__llFBZ","link":"styles_link__ng-Q5"};